module.exports = __webpack_public_path__ + "../resources/images/emoji-a0bdf107114572f8836934f1de194fe8.svg";